module.exports = __webpack_public_path__ + "image/p3-p6.1782790484418.jpg";